import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return new Promise(async resolve => {
      const isLogged = await this.authService.isLogged();
      const isLoginPage = state.url === '/login';
      if (isLogged || isLoginPage) {
        resolve(true);
      } else {
        this.router.navigateByUrl('/login', {
          queryParams: { returnUrl: state.url },
        });
        resolve(false);
      }
    });
  }
}
